import { BasicModel } from '../basic/basic.model';
import { BasicWithLibelleModel } from '../basic/basicWithLibelle.model';

export class NaModel extends BasicModel implements BasicWithLibelleModel {
    code: string;
    libelle: string;
    idCgCharge: number;
    idTypeComp: string;
    cgCharge: string;
    typeComp: string;
    analyt2: boolean;
}
